export const questionsData = [
  {
    id: 1,
    question: "Which of the following is the correct name of React.js?",
    options: [
      "React",
      "React.js",
      "ReactJS",
      "All of the above"
    ],
    answer: 3,
    point: 5
  },
  {
    id: 2,
    question: "Which of the following are the advantages of React.js?",
    options: [
      "React.js can increase the application's performance with Virtual DOM",
      "React.js is easy to integrate with other frameworks such as Angular, BackboneJS since it is only a view library",
      "React.js can render both on client and server side",
      "All of the above"
    ],
    answer: 3,
    point: 10
  },
  {
    id: 3,
    question: "Which of the following is not a disadvantage of React.js?",
    options: [
      "React.js has only a view layer. We have put your code for Ajax requests, events and so on.",
      "The library of React.js is pretty large",
      "The JSX in React.js makes code easy to read and write",
      "The learning curve can be steep in React.js"
    ],
    answer: 2,
    point: 20
  },
  {
    id: 4,
    question: "Which of the following command is used to install create-react-app?",
    options: [
      "npm install -g create-react-app",
      "npm install create-react-app",
      "npm install -f create-react-app",
      "install -g create-react-app"
    ],
    answer: 2,
    point: 25
  }

];